export const HomeRoute = {
    label: '首页',
    value: 'sysHome',
    permission: 'sysHome',
    menu: 0,
    show: true,
    path: '/',
}
export const PlanRoute={
    label: '开放API',
    value: 'dockingPlan',
    permission: 'dockingPlan',
    menu: 9,
    show: true,
    path: '/dockingPlan',
}